<template>
  <div class="cover">
    <nav-header
      v-bind:showSearch="p_showSearch"
      v-bind:loginModalFlag="p_loginModalFlag"
      v-bind:showOrNot="p_showOrNot"
      v-on:showLoginModal="p_showLoginModal"
      v-on:closeLoginModal="p_closeLoginModal">
    </nav-header>
    <div class="cover_in">
      <img class="banner banner-phone" src="../../assets/novel-coronavirus/sample-banner.png" alt="">
      <img class="banner banner-pc" src="../../assets/novel-coronavirus/sample-banner-pc.png" alt="">
      <div class="explain">
        <div class="explain_title">
          意义和作用：
        </div>
        <div class="explain_content">
          <p>1、安全复工，避免存在无症状感染者导致病毒传播</p>
          <p>2、员工居家自检，避免人群聚集交叉感染</p>
          <p>3、缩短复工复产周期，减少企业损失</p>
        </div>
        <div class="explain_title">
          适用场景：
        </div>
        <div class="explain_content">
          <p>复工复产企事业单位</p>
        </div>
        <div class="explain_title">
          操作流程：
        </div>
      </div>
      <div class="process">
        <div class="step">
          <img src="../../assets/novel-coronavirus/sample-step.png" alt="">
          <p>1</p>
        </div>
        <div class="process_content">
          <div class="process_title">
            申请入口
          </div>
          <div class="process_intro">
            填写自采样新冠病毒筛查申请表，等待工作人员评估确认(约1个工作日)
          </div>
          <div class="process_btn" @click="toApply">
            <p>填写申请表 > </p>
          </div>
        </div>
      </div>
      <div class="process">
        <div class="step">
          <img src="../../assets/novel-coronavirus/sample-step.png" alt="">
          <p>2</p>
        </div>
        <div class="process_content">
          <div class="process_title">
            上传「授权同意函」和「检测名单」
          </div>
          <div class="process_intro">
            填写下方模板，向所在地新冠疫情防控工作指挥部申请申请授权并盖章后上传
          </div>
          <div class="process_btn" @click="toUpload">
            <p>上传入口 > </p>
          </div>
          <a class="template" @click="toTemplate">下载模板</a>
        </div>
      </div>
      <div class="process">
        <div class="step">
          <img src="../../assets/novel-coronavirus/sample-step.png" alt="">
          <p>3</p>
        </div>
        <div class="process_content">
          <div class="process_title">
            下单
          </div>
          <div class="process_intro">
            工作人员收到申请表和授权文件后1个工作日内开通下单权限，可用申请表中的手机号登录系统，选择相应的检测产品下单
          </div>
          <div class="process_btn" @click="toOrder">
            <p>开始下单 > </p>
          </div>
        </div>
      </div>
      <div class="process">
        <div class="step">
          <img src="../../assets/novel-coronavirus/sample-step.png" alt="">
          <p>4</p>
        </div>
        <div class="process_content">
          <div class="process_title">
            发货
          </div>
          <div class="process_intro">
            工作人员审核订单并发货
          </div>
        </div>
      </div>
      <div class="process">
        <div class="step">
          <img src="../../assets/novel-coronavirus/sample-step.png" alt="">
          <p>5</p>
        </div>
        <div class="process_content">
          <div class="process_title">
            采样
          </div>
          <div class="process_intro">
            根据自采样指导视频教程进行采样
          </div>
          <div class="process_code">
            <img src="../../assets/novel-coronavirus/sample-code.png" alt="">
            <p>扫描观看</p>
          </div>
        </div>
      </div>
      <div class="process">
        <div class="step">
          <img src="../../assets/novel-coronavirus/sample-step.png" alt="">
          <p>6</p>
        </div>
        <div class="process_content">
          <div class="process_title">
            送检
          </div>
          <div class="process_intro">
            企业根据生物安全二级防护标准（如穿戴一次性医用防护服、护目镜、双层手套、N95口罩、防护靴套等）进行送检
          </div>
        </div>
      </div>
      <div class="process">
        <div class="step">
          <img src="../../assets/novel-coronavirus/sample-step.png" alt="">
          <p>7</p>
        </div>
        <div class="process_content">
          <div class="process_title">
            检测&报告
          </div>
          <div class="process_intro">
            由具备新冠病毒检测能力的机构检测并出具报告(最快当天可出)
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import NavHeader from "@/components/Header.vue";
  import {getCookie, removeHTMLTag} from "../../util/util"

  export default {
    name: "NovelCoronavirusSample",
    data() {
      return {
        p_showSearch: true,
        p_loginModalFlag: false,
        p_showOrNot: 'not',
        sampleStatus: '0'
      }
    },
    computed: {

    },
    components: {
      NavHeader
    },
    mounted() {
      this.load()
    },
    methods: {
      p_showLoginModal () {
        this.p_loginModalFlag = true;
      },

      p_closeLoginModal () {
        this.p_loginModalFlag = false;
      },
      load() {
        axios.get("/jys/questionnaire/xgStatus").then((res) => {
          this.sampleStatus = res.data.xgStatus
        })
      },
      toApply() {
        if (getCookie("_token")) {
          if (this.sampleStatus === '1') {
            this.$message.error('审核通过，无需填写')
          } else {
            this.$router.push({path: "/NovelCoronavirusApply"})
          }
        } else {
          window.scroll(0, 0)
          this.$message({
            showClose: true,
            message: '登录信息失效,请重新登录',
            type: 'error'
          });
          this.p_showLoginModal()
        }
      },
      toUpload() {
        if (getCookie("_token")) {
          if (this.sampleStatus === '1') {
            this.$message.error('审核通过，无需上传')
          } else {
            this.$router.push({path: "/NovelCoronavirusUpload"})
          }
        } else {
          window.scroll(0, 0)
          this.$message({
            showClose: true,
            message: '登录信息失效,请重新登录',
            type: 'error'
          });
          this.p_showLoginModal()
        }
      },
      toTemplate() {
        window.open('https://pic.jianyanwang.com/upload/20200227/78e1a4b01d8c4a79b31c55e9908ae04f.zip')
      },
      toOrder() {
        this.$router.push({
          path: "detection",
          query: {id: '380', remark: ''}
        })
      }
    }
  }
</script>

<style scoped>
  .cover{
    width: 100%;
    float: left;
    background-color: #eff8fd;
  }
  .cover_in{
    width: 100%;
    margin: 0 auto;
  }
  .cover .banner{
    width: 100%;
    float: left;
  }
  .explain{
    width: 100%;
    float: left;
    padding: 20px 40px 25px 40px;
    box-sizing: border-box;
    color: #131313;
    font-size: 13px;
  }
  .explain_title,
  .explain_content{
    width: 100%;
    float: left;
  }
  .explain_title{
    font-weight: bolder;
    padding-left: 10px;
    border-left: 3px solid #6FBBED;
  }
  .explain_content{
    padding: 10px 0 25px 13px;
  }
  .process{
    float: left;
    margin: 0 40px;
    padding: 20px 0;
    box-sizing: border-box;
    color: #888888;
    font-size: 13px;
    position: relative;
    border-left: 3px solid #6FBBED;
  }
  .step{
    position: absolute;
    top: 15px;
    left: -15px;
  }
  .process_content{
    float: left;
    margin: 0 0 0 35px;
  }
  .step img{
    width: 34px;
    height: 25px;
  }
  .step p{
    position: absolute;
    top: 3px;
    left: 10px;
    color: #ffffff;
  }
  .process_title{
    color: #4FADEB;
    font-weight: bolder;
    margin-bottom: 10px;
  }
  .process_intro{
    font-size: 12px;
    margin-bottom: 10px;
  }
  .process_btn{
    width: 100px;
    float: left;
    height: 25px;
    line-height: 25px;
    text-align: center;
    color: #ffffff;
    font-size: 12px;
    background-color: #6fbbed;
    cursor: pointer;
  }
  .template{
    margin-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 12px;
    color: #108EE9;
    text-decoration: underline;
    cursor: pointer;
  }
  .process_code {
    width: 80px;
    height: 80px;
    text-align: center;
    font-size: 12px;
  }
  .process_code img{
    width: 100%;
  }
  .process:last-child{
    margin-bottom: 50px;
  }
  .banner-phone{
    display: block;
  }
  .banner-pc{
    display: none;
  }
  @media only screen and (min-width: 600px) {
    .banner-phone{
      display: none;
    }
    .banner-pc{
      display: block;
    }
    .cover_in{
      width: 45%;
    }
    .step{
      top: 35px;
    }
    .process{
      width: 100%;
      padding: 40px 0;
    }
    .explain{
      padding-bottom: 50px;
    }
    .explain_content{
      padding-bottom: 50px;
    }
    .process_code{
      width: 100px;
      height: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/activities/novel-coronavirus-sample.vue